import styled from 'styled-components';
import { Button } from 'antd';
import { blue3, gray1 } from '@styles/styled/variables';

/* eslint-disable import/prefer-default-export */
export const StyledButton = styled(Button)`
  && {
    color: ${gray1};
    border: none;
    box-shadow: none;
    position: relative;
    left: -5px;
    &.expand {
      color: ${blue3};
    }
  }
`;
